<div class="container-xxl" id="about" data-aos="fade-up" data-aos-duration="1000">
    <div class="container">
        <div class="row g-5 align-items-center">
            <div class="col-lg-6 appear-animation" data-aos="fade-right" data-aos-duration="1000">
                <div class="about-img position-relative overflow-hidden">
                    <img class="img-fluid w-100" src="assets/img/About.jpg">
                </div>
            </div>
            <div class="col-lg-6" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000">
                <h1 class="display-5 mb-4 font-weight-bolder">Welcome to MyKadai</h1>
                <h3 class="mb-3">Your Local Marketplace, Just a Tap Away</h3>
                <p class="mb-4">MyKadai is a comprehensive online shopping and services platform designed to
                    simplify your everyday life. Whether you’re stocking up on groceries, ordering tonight’s dinner,
                    refilling medicines, booking a taxi, or just craving something sweet—MyKadai brings your
                    neighborhood shops and services directly to your phone.</p>
                <p class="mb-4">
                    We connect you to trusted local vendors, allowing you to shop and order from a wide range of
                    20,000+ products and services—anytime, anywhere.
                </p>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid bg-light bg-icon my-5 py-6">
    <div class="container">
        <div class="section-header text-center mx-auto mb-5 " data-wow-delay="0.1s"
             style="max-width: 500px; visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
            <h1 class="display-5 mb-3 font-weight-bolder">Why MyKadai?</h1>
            <p>We connect you to trusted local vendors, allowing you to shop and order from a wide range of
                20,000+ products and services—anytime, anywhere</p>
        </div>
        <div class="row g-4">
            <div class="col-lg-4 col-md-6">
                <div class="bg-white text-center h-100 p-4 p-xl-5">
                    <img class="img-fluid mb-4 icon-size" src="assets/img/icons/all%20in%20one%20convenience.png"
                         alt="">
                    <h4 class="mb-3">All-in-One Convenience</h4>
                    <p class="mb-4">Skip the traffic and queues. From fresh produce to taxi rides, everything you
                        need is available under one platform.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 ">
                <div class="bg-white text-center h-100 p-4 p-xl-5">
                    <img class="img-fluid mb-4 icon-size" src="assets/img/icons/personalized.png"
                         alt="">
                    <h4 class="mb-3">Hyperlocal & Personalized</h4>
                    <p class="mb-4">Shop from your nearby stores and enjoy faster deliveries, familiar service, and
                        community support.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 ">
                <div class="bg-white text-center h-100 p-4 p-xl-5">
                    <img class="img-fluid mb-4 icon-size" src="assets/img/icons/quality.png"
                         alt="">
                    <h4 class="mb-3">Quality & Trust</h4>
                    <p class="mb-4">We partner only with verified vendors and service providers to ensure quality,
                        reliability, and satisfaction with every order.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid my-5 py-6">
    <div class="container">
        <div class="section-header text-center mx-auto mb-5 ">
            <h1 class="display-7 mb-3 font-weight-bolder">What Can You Order?</h1>
        </div>
        <div class="row gy-4">
            <div class="col-lg-4 col-md-6">
                <h4 class="text-bold mb-2 text-center">Grocery & Fresh Produce</h4>
                <div class="single-img">
                    <img src="assets/img/icons/grocery.png" alt="Avatar" class="image p-5">
                    <div class="img-overlay">
                        <div class="text">
                            <p class="text-bold">Farm-fresh fruits and vegetables, pantry staples,
                                organic products, and everyday essentials—all delivered
                                fresh and fast.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <h4 class="text-bold mb-2 text-center">Restaurants</h4>
                <div class="single-img">
                    <img src="assets/img/icons/restaurant.png" alt="Avatar" class="image p-5">
                    <div class="img-overlay">
                        <div class="text">
                            <p class="text-bold">Order from your favorite local eateries, cafés, and dessert spots.
                                Whether it’s a full meal or a midnight snack, we deliver it hot and tasty.</p>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-4 col-md-6">
                <h4 class="text-bold mb-2 text-center">Pharmacy & Ayurveda</h4>
                <div class="single-img">
                    <img src="assets/img/icons/pharmacy.png" alt="Avatar" class="image p-5">
                    <div class="img-overlay">
                        <div class="text">
                            <p class="text-bold">Access a wide range of health products, prescription medicines, and
                                natural wellness items with doorstep delivery and safety compliance.</p>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-4 col-md-6">
                <h4 class="text-bold mb-2 text-center"> Fresh Meat & Seafood</h4>
                <div class="single-img">
                    <img src="assets/img/icons/meat.png" alt="Avatar" class="image p-5">
                    <div class="img-overlay">
                        <div class="text">
                            <p class="text-bold">Hygienically packed, freshly sourced meat and seafood options from
                                trusted local vendors.</p>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-4 col-md-6">
                <h4 class="text-bold mb-2 text-center">Stationery</h4>
                <div class="single-img">
                    <img src="assets/img/icons/office-supplies.png" alt="Avatar" class="image p-5">
                    <div class="img-overlay">
                        <div class="text">
                            <p class="text-bold">School and office supplies—all
                                available in a few clicks.</p>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-4 col-md-6">
                <h4 class="text-bold mb-2 text-center">Bakery</h4>
                <div class="single-img">
                    <img src="assets/img/icons/bakery.png" alt="Avatar" class="image p-5">
                    <div class="img-overlay">
                        <div class="text">
                            <p class="text-bold">Breads, cakes, party essentials,
                                available in a few clicks.</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>


<div class="container-fluid bg-light bg-icon my-5 py-6">
    <div class="container">
        <div class="section-header text-center mx-auto mb-5" data-aos="fade-right" data-aos-delay="200">
            <h1 class="display-5 mb-3 font-weight-bolder">Deals & Offers You’ll Love</h1>
        </div>
        <div class="row g-4">
            <div class="custom-panel">
                <div class="panel-left col-lg-3 col-md-6">
                    <div
                            class="panel-item"
                            *ngFor="let item of sections; let i = index"
                            [class.active]="selectedIndex === i"
                            (click)="selectSection(i)"
                    >
                        {{ item.title }}
                    </div>
                </div>

                <div class="panel-right col-lg-9 col-md-6" *ngIf="selectedSection">
                    <h4 class="text-center">{{ selectedSection.description }}</h4>
                    <img src="{{ selectedSection.image }}" class="img-fluid" alt="Preview"/>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="container-fluid my-5 py-6">
    <div class="container">
        <div class="section-header text-center mx-auto mb-5" data-aos="fade-right" data-aos-delay="200">
            <h1 class="display-5 mb-3 font-weight-bolder">Powered by Your Local Community</h1>
        </div>
        <div class="row g-4">
            <div class="col-12 text-center">
                <h6 class="font-weight-normala">MyKadai supports local vendors by giving them a platform to reach
                    digital customers. Every order you place helps your local economy thrive—while you enjoy unmatched
                    convenience and quality.</h6>
            </div>
        </div>
    </div>
</div>


<div class="container-fluid my-5 py-6 bg-light bg-icon">
    <div class="container">
        <div class="section-header text-center mx-auto mb-5" data-aos="fade-right" data-aos-delay="200">
            <h1 class="display-5 mb-3 font-weight-bolder">Easy, Fast & Secure Checkout</h1>
            <p>Enjoy a smooth and secure shopping experience with our streamlined checkout process</p>
        </div>
        <div class="row g-4">
            <div class="feature-grid">
                <div class="feature-box">
                    <i class="fas fa-credit-card"></i>
                    <p>Multiple online payment options</p>
                </div>
                <div class="feature-box">
                    <i class="fas fa-clock"></i>
                    <p>Instant confirmation and real-time order tracking</p>
                </div>
                <div class="feature-box">
                    <i class="fas fa-lock"></i>
                    <p>Encrypted transactions and privacy protection</p>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="container-fluid my-5 py-6">
    <div class="container">
        <div class="section-header text-center mx-auto mb-5" data-aos="fade-right" data-aos-delay="200">
            <h1 class="display-5 mb-3 font-weight-bolder">How It Works?</h1>
        </div>
        <div class="steps-container">
            <div class="step">
                <div class="icon"><i class="bi bi-geo-alt-fill"></i></div>
                <h3>Set Your Location</h3>
                <p>Allow location access so we can show shops within 5 KM around you.</p>
            </div>
            <div class="step">
                <div class="icon"><i class="bi bi-geo-fill"></i></div>
                <h3>Explore Nearby Shops</h3>
                <p>Discover local stores and their products, all in one place.</p>
            </div>
            <div class="step">
                <div class="icon"><i class="bi bi-shop-window"></i></div>
                <h3>Pick Your Favorite Shops</h3>
                <p>Follow or favorite shops you like for quick access and updates.</p>
            </div>
            <div class="step">
                <div class="icon"><i class="bi bi-bag-check-fill"></i></div>
                <h3>Add Products to Cart or Wishlist</h3>
                <p>Found what you need? Add to cart for now or wishlist for later—your choice!</p>
            </div>
            <div class="step">
                <div class="icon"><i class="bi bi-credit-card-2-front-fill"></i></div>
                <h3>Secure Checkout & Payment</h3>
                <p>Confirm your order with safe and simple payment options.</p>
            </div>
            <div class="step">
                <div class="icon"><i class="bi bi-cart-check-fill"></i></div>
                <h3>Track Your Order</h3>
                <p>Get real-time updates as your order is prepared and delivered.</p>
            </div>
            <div class="step">
                <div class="icon"><i class="bi bi-star-fill"></i></div>
                <h3>Rate & Review</h3>
                <p>Share your feedback and keep supporting your favorite local shops!.</p>
            </div>
        </div>
    </div>
</div>


<div class="container-fluid bg-light bg-icon my-5 py-6" id="contact">
    <div class="container text-center">
        <div class="section-header text-center mx-auto mb-5 " data-aos="flip-up">
            <h1 class="display-5 mb-3 font-weight-bolder">Download the MyKadai App</h1>
        </div>
        <img src="assets/img/mykadainew.png" alt="My Kadai Logo" class="img-fluid logo">
        <h2 class="get-started">Get started today!</h2>
        <p>Experience the ease of shopping and ordering services through a single app.</p>
        <p class="available-on">👉 Available now on Android & iOS</p>
        <div class="download-buttons">
            <a href="https://play.google.com/store/apps/details?id=cloud.varnik.mykadai&pcampaignid=web_share"
               class="android-button" target="_blank">
                <i class="fab fa-google-play fa-lg mr-2"></i>
                <span>Google Play</span></a>
            <a href="#" class="ios-button" target="_blank">
                <i class="fab fa-apple fa-lg mr-2"></i>
                <span>App Store</span></a>
        </div>
        <p class="tagline">Your Trendsetting Destination!</p>
    </div>
</div>